"use client";

import { useCalendarContext } from "../calendar-context";
import { atMinutes, formatTime } from "../utils";

import { NowLabel } from "./now-indicator";

// =============================================================================

// Any day works: only the hour is formatted
const REFERENCE_DAY = new Date(2000, 0, 3);

type TimeGutterProps = {
  /** Today is on screen: show the current time label */
  showNow: boolean;
};

/** Hours column, sticky on the left during horizontal scrolling */
export function TimeGutter({ showNow }: TimeGutterProps) {
  const { locale, minHour, maxHour } = useCalendarContext();
  const hours = Array.from(
    { length: maxHour - minHour },
    (_, i) => minHour + i
  );

  return (
    <div
      aria-hidden
      className="sticky left-0 z-10 w-16 shrink-0 border-r border-line bg-background select-none"
    >
      {hours.map((hour) => (
        <div key={hour} className="relative h-(--calendar-hour-height)">
          {/* Centered on the hour line; the first one would hide under the header */}
          {hour > minHour && (
            <span className="absolute -top-2 right-2 text-xs leading-4 whitespace-nowrap text-muted-foreground tabular-nums">
              {formatTime(atMinutes(REFERENCE_DAY, hour * 60), locale)}
            </span>
          )}
        </div>
      ))}
      {showNow && <NowLabel />}
    </div>
  );
}
